/**
 * Tween and easing utility functions.
 */

/** Linear interpolation. */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** Ease-out cubic. Fast start, slow finish. */
export function easeOutCubic(t: number): number {
  return 1 - Math.pow(1 - t, 3);
}

/** Ease-in-out sine. Smooth start and end. */
export function easeInOutSine(t: number): number {
  return -(Math.cos(Math.PI * t) - 1) / 2;
}

/**
 * Parabolic arc — adds vertical lift peaking at t=0.5.
 * Returns the Y offset (negative = upward) to add to a linear path.
 */
export function parabolicArc(t: number, height: number): number {
  return -height * Math.sin(t * Math.PI);
}
